import { MARQUEE_ITEMS } from "../lib/data";

const Row = () => (
  <div className="flex items-center shrink-0">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display font-semibold text-lg lg:text-xl text-[#2A2521]/80 px-6 whitespace-nowrap">{item}</span>
        <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 shrink-0" fill="#A6823B" aria-hidden="true">
          <path d="M12 2C9.5 2 9 3.6 7 3.6 4.8 3.6 3 5.5 3 8c0 1.9.9 3.1 1.4 4.6.4 1.4.7 3 .9 4.7.2 1.7.5 4.7 2.2 4.7 1.9 0 1.2-3.6 2.2-5.7.4-.9 1-1.6 2.3-1.6s1.9.7 2.3 1.6c1 2.1.3 5.7 2.2 5.7 1.7 0 2-3 2.2-4.7.2-1.7.5-3.3.9-4.7C21.1 11.1 22 9.9 22 8c0-2.5-1.8-4.4-4-4.4-2 0-2.5-1.6-6-1.6z" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section className="py-8 border-y border-[#EADFC6] bg-[#FBF7EF] overflow-hidden" data-testid="marquee-section" aria-label="Tratamente disponibile">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
